import { render, staticRenderFns } from "./dynamic-comment-pdfView.vue?vue&type=template&id=7b8c580e&scoped=true&"
import script from "./dynamic-comment-pdfView.vue?vue&type=script&lang=js&"
export * from "./dynamic-comment-pdfView.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-comment-pdfView.vue?vue&type=style&index=0&id=7b8c580e&prod&lang=scss&"
import style1 from "./dynamic-comment-pdfView.vue?vue&type=style&index=1&id=7b8c580e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8c580e",
  null
  
)

export default component.exports